import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ControlledCheckbox from './ControlledCheckbox';
import ClientProvider from './client';
export default createDemo(import.meta.url, ControlledCheckbox, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/checkboxes/demos/controlled/ControlledCheckbox.tsx",
    "fileName": "ControlledCheckbox.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Checkbox from '@mui/material/Checkbox';\n\nexport default function ControlledCheckbox() {\n  const [checked, setChecked] = React.useState(true);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setChecked(event.target.checked);\n  };\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Checkbox\n      checked={checked}\n      onChange={handleChange}\n      slotProps={{\n        input: { 'aria-label': 'controlled' },\n      }}\n    />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Checkbox from '@mui/material/Checkbox';\n\nexport default function ControlledCheckbox() {\n  const [checked, setChecked] = React.useState(true);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setChecked(event.target.checked);\n  };\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Checkbox\n      checked={checked}\n      onChange={handleChange}\n      slotProps={{\n        input: { 'aria-label': 'controlled' },\n      }}\n    />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "slotProps"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "        ",
              [
                "span",
                "di-op di-jv",
                "input"
              ],
              ": { ",
              [
                "span",
                "pl-s di-op di-ps di-jv",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "aria-label",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "controlled",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " },"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            "    />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Checkbox"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
